export const environment = {
  production: true,
  apiUrl: 'https://globalassethub-dev.sonypictures.com/gahapi',
  baseUrl: 'https://globalassethub-dev.sonypictures.com',
  stripoPluginStaticSource: 'https://plugins.stripo.email/static/latest/stripo.js',
  stripoPluginAuth : 'https://plugins.stripo.email/api/v1/auth',
  okta: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa1lp2t55l7YPTHB358',
    redirectUri: 'https://globalassethub-dev.sonypictures.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://globalassethub-dev.sonypictures.com'
  },
  oktapublicity: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa1lp2t55l7YPTHB358',
    redirectUri: 'https://dev.sonypicturespublicity.net/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://dev.sonypicturespublicity.net'
  },
  oktapublicityaus: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa1lp2t55l7YPTHB358',
    redirectUri: 'https://www.sonypicturespublicity.com.au/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com.au'
  },
  oktapublicitydotcom: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa1lp2t55l7YPTHB358',
    redirectUri: 'https://www.sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com'
  },
  oktapublicityfr: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa1lp2t55l7YPTHB358',
    redirectUri: 'https://www.sonypicturespresse.fr/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespresse.fr'
  },
  oktapublicitynz: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa1lp2t55l7YPTHB358',
    redirectUri: 'https://www.sonypicturespublicity.co.nz/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.co.nz'
  },
  oktapublicity1: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa1lp2t55l7YPTHB358',
    redirectUri: 'https://sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://sonypicturespublicity.com'
  },
  captchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  gtmId: 'GTM-54NFTQ9B',
  gtmId_ns: 'GTM-PPVFC757',
  gtmScriptUrl: 'https://www.googletagmanager.com/gtm.js',
  gtmNoScriptUrl: 'https://www.googletagmanager.com/ns.html'
};